import { FunctionComponent, ReactElement } from 'react';

const LeviantLogo: FunctionComponent = (): ReactElement => (
	<svg width="104" height="18" viewBox="0 0 104 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M98.5498 2.04315H96.85V3.73704H98.5498V2.04315Z" fill="#0084D4" />
		<path
			d="M96.85 5.42929V3.7354H95.1518V2.04315H85.8278V7.12153H91.3719V18H96.85V7.12153H98.5498V5.42929H96.85Z"
			fill="#0084D4"
		/>
		<path d="M101.949 2.04315H100.25V3.73704H101.949V2.04315Z" fill="#0084D4" />
		<path
			d="M99.4 3.38415L98.198 4.58191L99.4 5.77967L100.602 4.58191L99.4 3.38415Z"
			fill="#0084D4"
		/>
		<path
			d="M102.796 0L101.594 1.19777L102.796 2.39553L103.998 1.19776L102.796 0Z"
			fill="#0084D4"
		/>
		<path
			d="M102.798 3.38398L101.596 4.58174L102.798 5.7795L104 4.58174L102.798 3.38398Z"
			fill="#0084D4"
		/>
		<path d="M101.949 5.42929H100.25V7.12318H101.949V5.42929Z" fill="#0084D4" />
		<path d="M5.47802 2.04315V12.92H11.3049V18H0V2.04315H5.47802Z" fill="#0084D4" />
		<path
			d="M23.8152 2.04315V6.31907H18.0528V7.9899H23.4961V12.0533H18.0528V13.7257H23.8152V18H12.5732V2.04315H23.8152Z"
			fill="#0084D4"
		/>
		<path
			d="M24.8735 2.04315H30.502L33.4534 10.2111L36.4049 2.04315H42.0334L36.0875 18H30.8194L24.8735 2.04315Z"
			fill="#0084D4"
		/>
		<path d="M48.7185 2.04315H43.2388V18H48.7185V2.04315Z" fill="#0084D4" />
		<path
			d="M56.2981 15.736L55.4912 18H49.9487L55.683 2.04315H61.7579L67.4906 18H61.9266L61.1197 15.736H56.2981ZM58.7188 8.15961L57.2538 12.223H60.1838L58.7188 8.15961Z"
			fill="#0084D4"
		/>
		<path
			d="M84.5596 18H78.6979L74.0268 10.8257V18H68.7158V2.04315H74.5774L79.2502 9.21747V2.04315H84.5596V18Z"
			fill="#0084D4"
		/>
	</svg>
);

export default LeviantLogo;
